import { bindHTTP } from '@frontend/schema';
import { AppointmentsService } from '@weave/schema-gen-ts/dist/schemas/appointments/v3/service.pb';
export const SchemaAppointmentsService = bindHTTP(AppointmentsService);
